export const KlpPalette = {
    primary: {
        main: '#3d3d3d',
        dark: '#2e2e2e',
        mediumDark: '#737373',
        medium: '#b3b3b3',
        mediumLight: '#e1e1e1',
        light: '#f0f0f0',
        veryLight: '#f9f9f9',
    },
    secondary: {
        main: '#e41b65',
        dark: '#b22852',
        medium: '#ffd1d1',
        light: '#ffe1e1',
        veryLight: '#fff1f1',
    },
    tertiary: {
        main: '#0db28a',
        dark: '#06735c',
        medium: '#cdfae2',
        light: '#e3f9ed',
        veryLight: '#edfbf3',
    },
    error: {
        main: '#e41b65',
        light: '#ffe1e1',
    },
    background: {
        default: '#FFF',
        main: '#FFF',
        dark: '#FFF',
        mediumDark: '#FFF',
        medium: '#FFF',
        mediumLight: '#FFF',
        light: '#FFF',
        veryLight: '#FFF',
    },
};
